import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Box, Typography, buttonClasses, inputBaseClasses, styled, typographyClasses } from "@mui/material";
import { Dispatch, RefObject, SetStateAction } from "react";
import StripeDiscountModal from "../discount-components/StripeDiscountModal";
import CommonButton, { CommonButtonSecondarySx } from "../utils/CommonButton";
import CommonSwitch from "../utils/CommonSwitch";
import SearchField from "../utils/SearchField";
import CreateLazoCompanyModal from "./create-new-company-components/CreateLazoCompanyModal";

export const TableActions = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  padding: "1rem",
  justifyContent: "space-between",
  [`& .${inputBaseClasses.root}`]: {
    height: "2.750rem",
    width: "14.000rem",
    [theme.breakpoints.down("md")]: {
      width: "12.000rem",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  "& .filter-container": {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "1rem",
    [theme.breakpoints.down("sm")]: {
      gap: "0.75rem",
      flexWrap: "wrap",
    },
    [`& .${typographyClasses.root}`]: {
      fontSize: "0.750rem",
      fontWeight: "500",
    },
    [`& .${buttonClasses.root}`]: {
      borderRadius: "0.500rem",
      padding: "0.750rem 1.000rem",
      [theme.breakpoints.down("sm")]: {
        padding: "0.5rem 0.75rem",
      },
      [`& .${typographyClasses.root}`]: {
        fontSize: "0.875rem",
        fontWeight: "600",
        [theme.breakpoints.down("sm")]: {
          fontSize: "0.75rem",
        },
      },
    },
  },
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    gap: "1rem",
    alignItems: "stretch",
  },
}));

interface CustomerTableActionsProps {
  showFilters: boolean;
  setShowFilters: Dispatch<SetStateAction<boolean>>;
  handleSearch: (searchRef: RefObject<HTMLInputElement>) => void;
  setShowUnassignedOnly: (v: boolean) => void;
  hideUnassignedFilter?: boolean;
  showCreateCompanyAction?: boolean;
  showStripeDiscountAction?: boolean;
  search?: string;
  setSearch?: Dispatch<SetStateAction<string>>;
  route?: string;
}

function CustomerTableActions({
  showFilters,
  hideUnassignedFilter,
  setShowFilters,
  handleSearch,
  setShowUnassignedOnly,
  showCreateCompanyAction,
  showStripeDiscountAction,
  search,
  setSearch,
  route,
}: CustomerTableActionsProps) {
  return (
    <TableActions>
      <SearchField
        iconVariant
        handleSearch={handleSearch}
        displaySearchButton={false}
        triggerSearchOnInputChange={true}
        setSearch={setSearch}
        search={search}
        route={route}
      />
      <Box className="filter-container">
        {!hideUnassignedFilter && (
          <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <CommonSwitch onChange={(_, checked) => setShowUnassignedOnly(checked)} />
            <Typography>Show unassigned only</Typography>
          </Box>
        )}
        {showCreateCompanyAction && <CreateLazoCompanyModal />}
        {showStripeDiscountAction && <StripeDiscountModal />}

        <CommonButton
          endIcon={!showFilters ? <ExpandMore /> : <ExpandLess />}
          sx={{ ...CommonButtonSecondarySx, height: "2.5rem" }}
          onClick={() => setShowFilters(!showFilters)}
        >
          <Typography>Filters</Typography>
        </CommonButton>
      </Box>
    </TableActions>
  );
}

export default CustomerTableActions;
